<template>
  <!-- 选择部门  -->
  <el-tree ref="hSelectDeptTree" :style="{'background-color':backgroundColor}" :default-checked-keys="defaultCheckedKeys" node-key="id" class="h-select-dept" :expand-on-click-node="false" :load="loadNode" lazy :data="treeList" :props="defaultProps" @node-click="handleNodeClick"></el-tree>
</template>
<script>
export default {
  data() {
    return {
      userDeptId: '',
      treeList: [],
      defaultProps: {
        children: 'children',
        label: 'deptName',
        value: 'id',
      },
      currentDept: null,
      defaultCheckedKeys: [],
    }
  },
  props: {
    backgroundColor: {
      type: String,
      default: '#fff',
    },

    // value: {
    //   type: String,
    //   default: '选择用户'
    // },
  },
  created() {
    this.getUserInfo()
  },
  mounted() {
    // let nodedata = this.treeList[0].childNodes[0];
    // nodedata.expanded = true;
    // nodedata.loadData();
  },
  watch: {
    currentDept(val) {
      this.$emit('change', val)
    },
  },
  computed: {},
  methods: {
    getUserInfo() {
      let data = {}
      this.$API.getUserInfo(data).then(
        (res) => {
          console.log('获取用户信息', res)
          if (res && res.departmentId) {
            this.userDeptId = res.departmentId
            this.getAtPresentUserDepInfo()
          }
        },
        (err) => {
          console.log('获取用户信息失败', err)
        }
      )
    },
    //获取当前用户所在部门信息
    getAtPresentUserDepInfo() {
      let data = {}
      data.dept_id = this.userDeptId
      this.$API.getDepartmentDetail(data).then(
        (res) => {
          if (res) {
            this.currentDept = res
            this.treeList.push({
              deptName: res.deptName,
              id: res.id,
            })
            this.$nextTick(() => {
              this.$refs.hSelectDeptTree.setCurrentKey(res.id)
              setTimeout(() => {
                let node = this.$refs.hSelectDeptTree.getNode(res.id)
                node.expanded = true
                node.loadData()
              }, 500)
            })
          }
        },
        (err) => {}
      )
    },
    //给部门添加数据
    loadNode(node, resolve) {
      console.log('***', node)
      if (node.level === 0) {
        return
      }
      let addTreeList = []
      setTimeout(() => {
        let data = {}
        data.superId = node.data.id
        this.$API.getDepartmentsList(data).then(
          (res) => {
            res.map((item) => {
              if (item.hasSubDept) {
                addTreeList.push({ deptName: item.deptName, id: item.id })
              } else {
                addTreeList.push({ deptName: item.deptName, id: item.id, leaf: true })
              }
            })
            setTimeout(() => {
              resolve(addTreeList)
            }, 200)
          },
          (err) => {}
        )
      }, 100)
    },

    //点击部门
    handleNodeClick(data) {
      this.currentDept = data
    },
  },
}
</script>
<style scoped lang="stylus">
.h-select-dept
  height 100%
  width 100%
.h-select-dept >>>.el-tree-node.is-current > .el-tree-node__content
  color #17A48B !important
  background #F5F5F5
.h-select-dept >>>.el-tree-node__content
  margin-top 8px
</style>



// WEBPACK FOOTER //
// src/components/parts/hSelectDept.vue